import { useState, useEffect } from 'react'

const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState<number>(0)

  if (typeof window === 'undefined') return scrollPosition

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.pageYOffset)

    window.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return scrollPosition
}

export default useScrollPosition
